import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import HttpRequestConstants from '../constants/http_request';
import actionTypes from '../constants/action_types';
import HttpRequest from './models/http_request';
class HttpRequestStoreClass extends ReduceStore {
  getInitialState() {
    return {
      shipping_fees: new HttpRequest,
      shipping_ad_fees: new HttpRequest,
      product_batch_stocks: new HttpRequest,
      cart_mixed_stocks_compute: new HttpRequest,
      product_mixed_stocks_fitting_options_compute: new HttpRequest,
      tyre_filter_options: new HttpRequest,
      moto_tyre_filter_options: new HttpRequest,
      cart_mixed_stocks_shipping_options_compute: new HttpRequest,
    };
  }

  reduce(state,  {source, action}) {
    if (source === actionTypes.HTTP_REQUEST_ACTION) {
      switch (action.type) {
        //ShippingFees
        case HttpRequestConstants.SHIPPING_FEES_STARTED:
          state.shipping_fees.started = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.SHIPPING_FEES_SUCCESS:
          state.shipping_fees.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.SHIPPING_FEES_FAILED:
          state.shipping_fees.failed = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.SHIPPING_AD_FEES_STARTED:
          state.shipping_ad_fees.started = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.SHIPPING_AD_FEES_SUCCESS:
          state.shipping_ad_fees.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.SHIPPING_AD_FEES_FAILED:
          state.shipping_ad_fees.failed = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.TYRE_FILTER_OPTIONS_STARTED:
          state.tyre_filter_options.started = true;
          this.__emitChange();
          break;

        case HttpRequestConstants.TYRE_FILTER_OPTIONS_SUCCESS:
          state.tyre_filter_options.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.TYRE_FILTER_OPTIONS_FAILED:
          state.tyre_filter_options.failed = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.MOTO_TYRE_FILTER_OPTIONS_STARTED:
          state.moto_tyre_filter_options.started = true;
          this.__emitChange();
          break;

        case HttpRequestConstants.MOTO_TYRE_FILTER_OPTIONS_SUCCESS:
          state.moto_tyre_filter_options.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.MOTO_TYRE_FILTER_OPTIONS_FAILED:
          state.moto_tyre_filter_options.failed = true;
          this.__emitChange();
          break;

        //ProductBatchStocks
        case HttpRequestConstants.PRODUCT_BATCH_STOCKS_STARTED:
          state.product_batch_stocks.started = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.PRODUCT_BATCH_STOCKS_SUCCESS:
          state.product_batch_stocks.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.PRODUCT_BATCH_STOCKS_FAILED:
          state.product_batch_stocks.failed = true;
          this.__emitChange();
          break;

          //ProductMixedStocksCompute
        case HttpRequestConstants.CART_MIXED_STOCKS_COMPUTE_STARTED:
          state.cart_mixed_stocks_compute.started = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.CART_MIXED_STOCKS_COMPUTE_SUCCESS:
          state.cart_mixed_stocks_compute.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.CART_MIXED_STOCKS_COMPUTE_FAILED:
          state.cart_mixed_stocks_compute.failed = true;
          this.__emitChange();
          break;

          //FittingOptionsCompute
        case HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_STARTED:
          state.product_mixed_stocks_fitting_options_compute.started = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_SUCCESS:
          state.product_mixed_stocks_fitting_options_compute.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_FAILED:
          state.product_mixed_stocks_fitting_options_compute.failed = true;
          this.__emitChange();
          break;

          //ShippingOptionsCompute
        case HttpRequestConstants.PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_STARTED:
          state.cart_mixed_stocks_shipping_options_compute.started = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_SUCCESS:
          state.cart_mixed_stocks_shipping_options_compute.success = true;
          this.__emitChange();
          break;
        case HttpRequestConstants.PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_FAILED:
          state.cart_mixed_stocks_shipping_options_compute.failed = true;
          this.__emitChange();
          break;

        case HttpRequestConstants.RESET_STATUS:
          if (state[action.payload] !== undefined) {
            state[action.payload].started = false;
            state[action.payload].success = false;
            state[action.payload].failed = false;
          }
          this.__emitChange();
          break;
      }
    }
    return state;
  }
    
}

const HttpRequestStore = new HttpRequestStoreClass(Dispatcher);
export default HttpRequestStore;